export default function getDashboardSitesReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_DASHBOARD_SITES_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_DASHBOARD_SITES_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_DASHBOARD_SITES_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}